import { render, staticRenderFns } from "./password-reset-success.vue?vue&type=template&id=6c1c9eba&scoped=true"
var script = {}
import style0 from "./password-reset-success.vue?vue&type=style&index=0&id=6c1c9eba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1c9eba",
  null
  
)

export default component.exports